import {SQFTResourceController} from "./SQFTResourceController";
import {WORKSPACE_RESOURCES} from "../../../../constants";

export class SelectedShapesController extends SQFTResourceController {

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.selectedShapes;
  }

  addShapeToSelection = (shape) => {
    this.addResource(shape);
  };

  removeShapeFromSelection = (shape) => {
    this.removeResource(shape);
  };

  clearSelection = () => {
    this.removeAllResources();
  };

  isShapeSelected = (shape) => {
    return this.getResources().includes(shape);
  };

  render = (ctx) => {
    void ctx
    // for (const ctx1 of ctx) {
    //
    // }

  }
}

